import React from 'react';
import { SingleSelect } from '~/components';

const options = [
  { id: 'true', name: 'Enabled' },
  { id: 'false', name: 'Disabled' },
];

export default function AssistantEnabledSelect({
  name,
  value,
  onChange,
  disabled,
  placeholder = 'AI Assistant',
  component: SelectComponent = SingleSelect,
  ...props
}) {
  return (
    <SelectComponent
      name={name}
      placeholder={placeholder}
      disabled={disabled}
      value={value}
      onChange={onChange}
      {...props}>
      {options.map((option) => (
        <option key={option.id} value={option.id}>
          {option.name}
        </option>
      ))}
    </SelectComponent>
  );
}
